module.exports = __webpack_public_path__ + "static/img/T7399_login_icon.684a05e2.png";